import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';

type SectionHeaderProps = {
  title: string;
  colorClass: string;
};

const useStyles = makeStyles()({
  sectionHeader: {
    borderRadius: '4px 4px 0 0',
    padding: '0.75rem',
    border: '1px solid ' + patientAccessTheme.palette.grey[300],
  },
});

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  colorClass,
}) => {
  const { classes } = useStyles();
  return (
    <Box className={`${classes.sectionHeader} ${colorClass}`}>
      <Typography fontSize="14px" fontType="medium" textColor="#fff">
        {title}
      </Typography>
    </Box>
  );
};
